<template>
    <div>
        <!-- Footer -->
        <div class="footer mt-3" :class="isMobile ? 'footer-sm' : 'footer-lg'" v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb'">
            <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
            <div class="align-items-center justify-content-lg-between">
                <div class="col-lg-12 text-center">
                    <ul class="nav nav-footer justify-content-between">
                        <li
                            class="nav-item"
                            @click="$router.push('/home')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto footer-nav-icon" src="https://storage.googleapis.com/spacetech2/shwemyanmar/home.png" alt="">
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{$t('footer.home')}}
                                </div>
                            </div>
                        </li>
                        <!-- <li
                            class="nav-item"
                            @click="openModal()"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                    {{
                                        $store.state.language === "en"
                                            ? "Download"
                                            : "ဒေါင်းလုတ်"
                                    }}
                                </div>
                            </div>
                        </li> -->
                        <!-- :class="linkIsActive('/deposit') ? 'active' : ''" -->
                        <li
                            class="nav-item"
                            @click="$router.push('/promotion')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto footer-nav-icon" src="https://storage.googleapis.com/spacetech2/shwemyanmar/marketing.png" alt="">
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{$t('footer.promotion')}}
                                </div>
                            </div>
                        </li>
                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/money-exchange%20(1).png" style="width: auto; height: 1.5rem;" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #000000;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->
                        <li
                            class="nav-item"
                            @click="$router.push('/deposit')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto footer-nav-icon" src="https://storage.googleapis.com/spacetech2/shwemyanmar/wallet.png" alt="">
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{$t('setting.deposit')}}
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item"
                        >
                            <a href="https://t.me/ShweKutKaiCompany_BOT" target="_blank" rel="noopener noreferrer">
                                <!-- https://t.me/hulk333vip -->
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto footer-nav-icon" src="https://storage.googleapis.com/spacetech2/shwemyanmar/customer-support.png" alt="">
                                    <div class="mx-auto pt-1 text-sm footer-nav-label">
                                        {{$t('setting.customer_service')}}
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li
                            class="nav-item"
                            @click="$router.push('/setting')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto footer-nav-icon" src="https://storage.googleapis.com/spacetech2/shwemyanmar/settings.png" alt="">
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{$t('footer.profile')}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';

export default {
  data() {
    return {
      is_live: false,
      isMobile: false,
    };
  },
  methods: {
    closeModal() {
      $('#download-modal').modal('hide');
    },
    openModal() {
      $('#download-modal').modal('show');
    },
    /* example link = '/settings' */
    linkIsActive(link) {
      console.log(this.$route.path === link);
      if (this.$route.path === link) return true;
      return false;
    },
    async fetchFootballLive() {
      try {
        const res = await axios.get('/football-lives');
        this.is_live = res.data.data[0].is_live;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchFootballLive();
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
  },
};
</script>
<style scoped>
.modal-content {
    border: 2px solid #0d5c2e;
}
td .fa-trash {
    color: #16a34a;
}
.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #0d5c2e;
}
.banking-icons {
    width: auto;
    height: auto;
    padding: 5px;
    border-radius: 5px;
}
.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    /* right: 0; */
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.nav-item {
    /* margin-left: 10px;
    margin-right: 10px; */
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    min-width: 60px;
}

/* PNG icons → dark red (matches site primary) */
.footer-nav-icon {
    width: auto;
    height: 1.5rem;
    /* filter: brightness(0) saturate(100%) invert(10%) sepia(98%) saturate(5200%) hue-rotate(332deg) brightness(0.68) contrast(1.18); */
}

/* Beat Argon `.footer .nav .nav-item .nav-link` and other globals */
.footer ul.nav-footer .nav-item,
.footer ul.nav-footer .nav-item .footer-nav-label,
.footer ul.nav-footer .nav-item .banking-icons,
.footer ul.nav-footer .nav-item a,
.footer ul.nav-footer .nav-item a:visited,
.footer ul.nav-footer .nav-item a .footer-nav-label {
    color: #14532d !important;
    text-decoration: none !important;
}

.footer ul.nav-footer .nav-item a:hover,
.footer ul.nav-footer .nav-item a:hover .footer-nav-label {
    color: #0d5c2e !important;
}
/* .nav-item:hover,
.nav-item.active {
    border-radius: 5px;
    background: #02133E;
    color: #16a34a !important;
} */
/* @media (max-width: 767.98px) { */
    .footer {
        bottom: 0;
        height: 4rem !important;
        width: 100%;
        /* background: white;#F5C0C2 */
        background: white;
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        /* color: #000000; */
        /* border-top: 2px solid black; */
    }
    .footer-sm {
        position: fixed;
    }
    .footer-lg {
        position: absolute;
    }
    .banking-icons {
        width: auto;
        height: auto;
        padding: 0.2rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 3px;
    }
    .footer {
        padding: 1px !important;
    }
    /* .banking-icons img {
        width: 25px;
        height: 25px;
        border-radius: 3px;
    } */
/* } */
</style>
